/// <amd-module name="Build/Designer/VisibilityMismatchWarning" />

import { SourceRepository } from "Build/Client/Contracts/Build";
import { IBuildLinkingService } from "Build/Client/Linking";

import * as Resources from "Build/Designer/Resources";

import { getTFSPageData } from "Tfs/Platform/Page";

import { ProjectVisibility } from "Tfs/Platform/Contracts/Core";
import { IVssPageContext } from "VSS/Platform/Context";
import { BannerContent } from "./WarningBanner";

export const bannerId = "_warnIfVisibilityMismatch";

export function isVisibilityMismatch(pageContext: IVssPageContext, repository: SourceRepository): boolean {
    const isPublicProject = _isPublicProject(pageContext);
    const isPublicRepo = !_isPrivateRepository(repository);
    return isPublicProject != isPublicRepo;
}

export function getBannerContent(pageContext: IVssPageContext, repository: SourceRepository): BannerContent {
    const isPrivateRepo = _isPrivateRepository(repository);
    const buildLinkingService = pageContext.getService<IBuildLinkingService>("IBuildLinkingService");
    return {
        id: bannerId,
        messageFormat: isPrivateRepo ? Resources.VisibilityMismatchRepoPrivate : Resources.VisibilityMismatchRepoPublic,
        links: [
            { name: Resources.VisibilityMismatchProjectSettings, href: buildLinkingService.getProjectSettingsUrl() },
            { name: Resources.LearnMore, href: "https://go.microsoft.com/fwlink/?linkid=2027430" }
        ]
    };
}

function _isPublicProject(pageContext: IVssPageContext): boolean {
    const pageData = getTFSPageData(pageContext);
    if (pageData && pageData.project && pageData.project.visibility) {
        const visibility = pageData.project.visibility;
        return visibility === ProjectVisibility.Public;
    }
    return false;
}

function _isPrivateRepository(repository: SourceRepository) {
    const property = "isPrivate";
    const propertyValue: string = repository.properties && repository.properties[property];
    return !!(propertyValue && propertyValue.toLowerCase() === "true");
}